const CHUNKS = {
    HOME: 'home',
    LISTING: 'listing',
    ITEM: 'item',
    COMPARE: 'compare',
    MEETING: 'meeting',
    CHAT: 'chat',
    PAYMENT: 'payment',
    PROFILE: 'profile',
    USERCONTENT: 'usercontent',
    SETTINGS: 'settings',
    MONETIZATION: 'monetization',
    ACCOUNT: 'account',
    POSTING: 'posting',
    REPROJECTS: 'reProjects',
    NOTFOUND: 'notfound',
    UPIFRAUDSAFETYTIPS: 'upitips',
    VERTICALS: 'verticals',
    SITEMAP: 'sitemap',
    LISTCATCOVER: 'listing|category-cover',
    COVID19ADVISORY: 'cov19adv',
    CATEGORYCOVER: 'category-cover',
    INSPECTIONCONSENT: 'InspectionConsent',
    CAMPAIGNS: 'Campaigns',
    LISTING_FILTERS: 'ListingFiltersPage',
    BOOK_APPOINTMENT: 'book-appointment',
    SELF_INSPECTION: 'self-inspection',
    SELECT_MAP_LOCATION: 'select-map-location',
    OLXAUTOS: 'olxAutos',
    FIND_OUR_STORES: 'find-our-stores',
    HOW_TO_SELL: 'how-to-sell',
    PRIVACY_POLICIES: 'privacy-policies',
    TERMS_CONDITION: 'terms-conditions',
    CONTACT_US: 'contact-us',
    FAQ: 'faq',
    ABOUT_US: 'about-us',
    COVIDSUPPORT: 'CovidSupport',
    APP_REDIRECTION: 'appRedirection',
    CHECKOUT_SHELL: 'checkout-shell',
    SELECT_INSPECTION_LOCATION: 'select-inspection-location',
    INSPECTION_BOOKING_HOME: 'inspection-booking-home',
    INSPECTION_BOOKING_STORE: 'inspection-booking-store',
    NON_CMC_CITY: 'non-cmc-city',
    BOOKING_CONFIRMATION: 'booking-confirmation',
    POLICY: 'policy',
    CONTACT_DETAILS: 'contact-details',
    MY_ZONE: 'my-zone'
};

module.exports = CHUNKS;
